import { ApiStatus, IWorkflow } from '../../models';
import {WebhookActions, WebhookActionTypes} from '../actions/webhookActions';

export const initialWebhookState: IWebhookState = {
  loadingListStatus: null,
  loadingStatus: null,
  updatingStatus: null,
}

export interface IWebhookState {
  loadingListStatus: ApiStatus | null;
  loadingStatus: ApiStatus | null;
  updatingStatus: ApiStatus | null;
}

export default function webhookReducer(
  state: IWebhookState = initialWebhookState,
  action: WebhookActions
): IWebhookState {

  switch (action.type) {
    case WebhookActionTypes.UPDATE_WEBHOOK:
      return {
        ...state,
        updatingStatus: ApiStatus.LOADING,
      };
    case WebhookActionTypes.UPDATING_WEBHOOK_FAILED:
      return {
        ...state,
        updatingStatus: ApiStatus.FAILED,
      };
    case WebhookActionTypes.UPDATED_WEBHOOK:
      return {
        ...state,
        updatingStatus: ApiStatus.LOADED,
      };
    case WebhookActionTypes.UNSET_WEBHOOKS:
      return {
        ...state,
        ...initialWebhookState,
      };
    default:
      return state;
  }
}
